import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@shared/lib/utils';

const statusBannerVariants = cva('rounded-xl px-4 py-3 text-sm leading-snug', {
  variants: {
    variant: {
      pending: 'border border-pending-foreground/40 bg-pending/10 text-foreground',
      destructive: 'border border-destructive/40 bg-destructive/10 text-destructive',
    },
  },
  defaultVariants: {
    variant: 'pending',
  },
});

export interface StatusBannerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusBannerVariants> {}

export function StatusBanner({ className, variant, role = 'status', ...props }: StatusBannerProps) {
  return (
    <div role={role} className={cn(statusBannerVariants({ variant }), className)} {...props} />
  );
}
